var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TouchableOpacity } from "react-native";
import { getFieldInfo, getFieldTitle } from "../../../../redux/form/form.utils";
import { formatAddress, isValidAddress } from "../../../../utils/address.utils";
import { getLocalizedText } from "../../../../utils/i18n/i18n.utils";
import FormInputText from "../FormInputText";
var FormInputAddressJsonFormSchema = /** @class */ (function (_super) {
    __extends(FormInputAddressJsonFormSchema, _super);
    function FormInputAddressJsonFormSchema() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Event handlers
        _this.handlePressSelectAddress = function () {
            var _a = _this.props, _b = _a.formContext, formContext = _b === void 0 ? {} : _b, name = _a.name, formData = _a.formData;
            if (formContext.onSelectMore) {
                formContext.onSelectMore(name, formData);
            }
        };
        _this.handlePressExtraInfo = function () {
            var _a = _this.props, _b = _a.formContext, formContext = _b === void 0 ? {} : _b, uiSchema = _a.uiSchema;
            if (formContext.onPressExtraInfo) {
                formContext.onPressExtraInfo(uiSchema.extraInfoUrl);
            }
        };
        return _this;
    }
    // Render
    FormInputAddressJsonFormSchema.prototype.render = function () {
        var _a = this.props, name = _a.name, uiSchema = _a.uiSchema, _b = _a.rawErrors, rawErrors = _b === void 0 ? [] : _b, onChange = _a.onChange, formData = _a.formData, _c = _a.formContext, formContext = _c === void 0 ? {} : _c;
        var customUiSchema = uiSchema;
        var placeholder = customUiSchema.placeholder, suffixText = customUiSchema.suffixText, isDisabled = customUiSchema.isDisabled;
        var disabled = isDisabled
            ? isDisabled(formContext.getAllFormData())
            : undefined;
        var handleChangeValue = function (input) {
            onChange(input);
            // TODO: Timeout?
            setTimeout(function () {
                if (formContext.onFieldChange) {
                    formContext.onFieldChange(name, input);
                }
            }, 0);
        };
        return (_jsx(TouchableOpacity, { onPress: this.handlePressSelectAddress, children: _jsx(FormInputText, __assign({}, customUiSchema, { onPressExtraInfo: this.handlePressExtraInfo, title: getFieldTitle(customUiSchema, formContext), info: getFieldInfo(customUiSchema, formContext), showDisclosureIcon: true, placeholder: placeholder, suffixText: suffixText, value: formData ? formatAddress(formData) : "", onChangeValue: handleChangeValue, error: rawErrors[0], disabled: disabled, textInputProps: {
                    editable: false,
                    pointerEvents: "none",
                } })) }));
    };
    // Validation
    FormInputAddressJsonFormSchema.validate = function (formData, errors, schema, uiSchema) {
        Object.keys(formData).forEach(function (fieldName) {
            var _a;
            var fieldUiSchema = uiSchema[fieldName];
            if (!fieldUiSchema) {
                return;
            }
            if (fieldUiSchema["ui:field"] !== "rentio:field:address") {
                return;
            }
            var fieldError = errors[fieldName];
            if (!fieldError) {
                return;
            }
            var data = formData[fieldName];
            if (!data) {
                return;
            }
            var isBirthAddress = ((_a = fieldUiSchema === null || fieldUiSchema === void 0 ? void 0 : fieldUiSchema.lookupTypes) === null || _a === void 0 ? void 0 : _a[0]) === "(cities)";
            if (isValidAddress(data, isBirthAddress)) {
                return;
            }
            fieldError.addError(getLocalizedText("system.form.error.invalid_address"));
        });
    };
    return FormInputAddressJsonFormSchema;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default FormInputAddressJsonFormSchema;
